import {BaSeButton, BaSeIcon} from "@base/react"
import {useEffect, useState} from "react"
import moment from "moment"
import {OpinionForm} from "./opinion-form";
import documentIcon from "../../assets/images/icons/documentIcon.svg"
import downloadIcon from "../../assets/images/icons/downloadIcon.svg"
import ApiPlannings from "../../services/planning";
import SideModal from "../modals/sidemodal";
import {eventTag} from "../../services/utils";
import Loading from "../loading";
import './index.scss'
import ApiGeneral from "../../services/general";

const api = ApiPlannings()
const event = {
  name: "accompaniment",
  category: "acompanhamento",
  action: "click",
}

export default function Opinion ({planningId = null, currentCnpj = null, show = false, closeModal, reopen}) {
  const [showModalOpinions, setShowModalOpinions] = useState(false)
  const [showModalDetails, setShowModalDetails] = useState(false)
  const [showModalGuidanceDetails, setShowModalGuidanceDetails] = useState(false)
  const [opinionsList, setOpinionsList] = useState({
    can_create: true,
    results: []
  })
  const [notesList, setNotesList] = useState([])
  const [opinion, setOpinion] = useState(null)
  const [selectedGuidance, setSelectedGuidance] = useState(null)
  const [loading, setLoading] = useState(true)
  const [tabActive, setTabActive] = useState('comments')

  const formatPublishedAt = (item) => {
    if (item?.dateHour) return item.dateHour.replace(' ', ' às ')

    const date = item?.dateHours || item?.created_at || item?.published_at
    return date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : ''
  }

  const formatCommentDate = (item, isDraft) => {
    const date = isDraft ? item?.created_at : (item?.published_at || item?.created_at)
    return date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : ''
  }

  const CardOpinion = ({item}) => {
    return (
      <div className={"dialog-opinion__card dialog-opinion__card--comment "+item.status} onClick={() => openOpinionDetails(item)}>
        <div className="dialog-opinion__card__text">
          <h3 className="dialog-opinion__card__title">
            {item?.name || "Acompanhamento" }
          </h3>
          <div className="dialog-opinion__card__meta">
            <p className="dialog-opinion__card__subtitle">
              <strong>Publicado em:</strong> {formatCommentDate(item, false)}
            </p>
            <p className="dialog-opinion__card__author">
              <strong>Publicado por:</strong> {item?.user?.name}
            </p>
          </div>
        </div>
        <BaSeIcon
          color="#09121F"
          description="Arrow"
          name="system/arrow-right-s-line"
          size={24}
        />
      </div>
    )
  }

  const closeModalOpinions = () => {
    setShowModalOpinions(false)
    closeOpinionDetails()
    closeGuidanceDetails()
    closeModal()
  }
  const openOpinionDetails = (data = null) => {
    setOpinion(data)
    setShowModalDetails(true)
    if (data) {
      eventTag(
        event?.name,
        event?.category,
        event?.action,
        `Comentário - ${data?.name || data?.title}`
      )
    }
    ApiGeneral().sendDigitalMoments('plan_opinion', {
      plan_id: planningId,
      cnpj: currentCnpj,
    })
  }
  const closeOpinionDetails = () => {
    setOpinion(null)
    setShowModalDetails(false)

    if (reopen) reopen()
  }
  const openGuidanceDetails = (data = null) => {
    setSelectedGuidance(data)
    setShowModalGuidanceDetails(true)
    eventTag(
      event?.name,
      event?.category,
      event?.action,
      `Orientação - ${data?.name || data?.title}`
    )
    ApiGeneral().sendDigitalMoments('plan_note', {
      plan_id: planningId,
      cnpj: currentCnpj,
      title: data?.name || data?.title,
    })
  }
  const closeGuidanceDetails = () => {
    setSelectedGuidance(null)
    setShowModalGuidanceDetails(false)
  }
  const handleDownloadReport = () => {
    if (!selectedGuidance?.report?.pdf) return

    window.open(selectedGuidance.report.pdf, '_blank', 'noopener,noreferrer')
  }

  const opinionsPublished = opinionsList?.results?.length ? opinionsList?.results.filter((item) => item.status === 'published') : []
  const hasOpinions = opinionsPublished.length > 0
  const hasGuidances = notesList.length > 0
  const hasContent = hasOpinions || hasGuidances

  const getList = async () => {
    setLoading(true)
    try {
      const {data: opinionsData} = await api.getOpinionsList(planningId)
      setOpinionsList(opinionsData)

      try {
        const {data: notesData} = await api.getPlanningNotes(planningId)
        const notes = notesData.data || []

        let reportData = null
        try {
          const {data} = await api.getPlanningReport(planningId)
          reportData = data?.pdf ? data : null
        } catch (error) {
          reportData = null
        }

        const notesWithReport = reportData && notes.length > 0
          ? notes.map((item, index) => (
            index === 0 ? {...item, report: reportData} : item
          ))
          : notes

        setNotesList(notesWithReport)
        if (!opinionsData?.results?.length && notes.length) {
          setTabActive('customer_guidelines')
        }
      } catch (error) {
        console.warn(error)
        setNotesList([])
      }
    } catch (e) {
      console.warn(e)
      setOpinionsList({
        can_create: true,
        results: []
      })
      setNotesList([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setShowModalOpinions(show)

    if (planningId && show) {
      setTabActive('comments')
      getList()
    }

    // eslint-disable-next-line
  }, [planningId, show])

  return (
    <>
      <SideModal
        callBackClose={() => {
          closeModalOpinions()
          eventTag(
            event?.name,
            event?.category,
            event?.action,
            `Fechar acompanhamento`
          )
        }}
        show={showModalOpinions}
        title="Acompanhamento"
        classCustom="follow-up"
        footer={
          opinionsList?.can_create && tabActive === 'comments' ? (
            <div className={"dialog-opinion__button center"}>
              <BaSeButton
                buttonType="button"
                color="#2E5DE6"
                size="medium"
                value="Novo comentário"
                width="auto"
                onClick={() => {
                  eventTag(
                    event?.name,
                    event?.category,
                    event?.action,
                    "Novo comentário"
                  )
                  openOpinionDetails()
                }}
              />
            </div>
          ) : null
        }
      >
        <div className={`dialog-opinion__content ${!hasContent ? 'center' : ''}`}>
          {
            loading ? (
              <div className="wrapper-loading-small">
                <Loading small />
              </div>
            ) : hasContent ? (
              <div className="dialog-opinion__tabs">
                <div className="dialog-opinion__tabs-head">
                  <button type="button"
                          onClick={() => setTabActive('comments')}
                          className={`btn-without-style tab ${tabActive === 'comments' ? 'active' : ''}`}>Comentários</button>
                  {
                    !!notesList.length && (<button type="button"
                                                   onClick={() => setTabActive('customer_guidelines')}
                                                   className={`btn-without-style tab ${tabActive === 'customer_guidelines' ? 'active' : ''}`}>Orientações ao cliente</button>)
                  }
                </div>
                <div className="dialog-opinion__tabs-body">
                  {
                    tabActive === 'comments' ? (
                      <div className="tab-content">
                        <div className="dialog-opinion__section">
                          <h6 className="dialog-opinion__subtitle">
                            Aqui você encontra qualquer comentário sobre o planejamento.
                          </h6>
                        </div>
                        {
                          opinionsPublished.length > 0 && (
                            <div className="dialog-opinion__section mb-0">
                              <h5 className="dialog-opinion__title">
                                Publicados
                              </h5>
                              <div className="dialog-opinion__cards">
                                {
                                  opinionsPublished.map((item) => (
                                    <CardOpinion item={item} key={item.id} />
                                  ))
                                }
                              </div>
                            </div>
                          )
                        }
                      </div>
                    ) : (
                      <div className="tab-content">
                        <div className="dialog-opinion__section">
                          <h6 className="dialog-opinion__subtitle">
                            Aqui você encontra orientações do consultor que realizou seu atendimento no app Sebrae.
                          </h6>
                          {
                            notesList.length > 0 ? (
                              <div className="dialog-opinion__cards">
                                {
                                  notesList.map((item) => (
                                    <div className={"dialog-opinion__card dialog-opinion__card--guidance "+(item.status || 'published')}
                                         key={`${item.title}-${item.dateHour}-${item.cpf}`}
                                         onClick={() => openGuidanceDetails(item)}>
                                      <div className="dialog-opinion__card__text">
                                        {
                                          item?.report?.pdf ? (
                                            <img
                                              src={documentIcon}
                                              alt="Documento"
                                              className="guidance-card-document-icon"
                                            />
                                          ) : ''
                                        }
                                        <div className="guidance-card-content">
                                          <h3 className="dialog-opinion__card__title">
                                            {item?.name || item?.title || "Orientacao ao cliente"}
                                          </h3>
                                          <div className="dialog-opinion__card__meta">
                                            <p className="dialog-opinion__card__subtitle">
                                              <><strong>Publicado em:</strong> {formatPublishedAt(item)}</>
                                            </p>
                                            <p className="dialog-opinion__card__author">
                                              <strong>Publicado por:</strong> {item?.user?.name || item?.author?.name || "Consultor"}
                                              {/* {item?.user?.cpf ? ` (${ maskCPF(item?.user?.cpf)})` : ''} */}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <BaSeIcon
                                        color="#09121F"
                                        description="Arrow"
                                        name="system/arrow-right-s-line"
                                        size={24}
                                      />
                                    </div>
                                  ))
                                }
                              </div>
                            ) : (
                              <div className="dialog-opinion__empty">Não há orientações cadastradas.</div>
                            )
                          }
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            ) : (
              <div className="dialog-opinion__empty">Não há comentário criado.</div>
            )
          }
        </div>
      </SideModal>
      {
        showModalOpinions ? (
          <SideModal
            callBackClose={() => {
              closeOpinionDetails()
              eventTag(
                event?.name,
                event?.category,
                event?.action,
                `Fechar comentário`
              )
            }}
            show={showModalDetails}
            title={opinion?.name || "Novo comentário"}
            disableCloseBackdrop={true}
            hideBackdrop={true}
            classCustom="follow-up"
          >
            <div className="dialog-opinion__form">
              <OpinionForm planningId={planningId} event={event} opinion={opinion} back={closeOpinionDetails} forceUpdateOpinions={getList} />
            </div>
          </SideModal>
        ) : ''
      }
      {
        showModalOpinions ? (
          <SideModal
            callBackClose={() => {
              closeGuidanceDetails()
              eventTag(
                event?.name,
                event?.category,
                event?.action,
                `Fechar orientação`
              )
            }}
            show={showModalGuidanceDetails}
            title={selectedGuidance?.title || "Orientacao ao cliente"}
            disableCloseBackdrop={true}
            hideBackdrop={true}
            classCustom="follow-up"
          >
            <div className="dialog-opinion__details">
              <div className="details-block">
                <h4>Nome do acompanhamento</h4>
                <p>
                  {selectedGuidance?.title || "-"}
                </p>
              </div>

              <div className="details-block">
                <h4>Descrição do acompanhamento</h4>
                <div
                  className="details-html"
                  dangerouslySetInnerHTML={{__html: selectedGuidance?.description || '-'}}
                />
              </div>

              {
                selectedGuidance?.report?.pdf ? (
                  <div
                    className="details-download-card"
                    onClick={handleDownloadReport}
                  >
                    <div className="details-download-card__text">
                      <p className="details-download-card__title">
                        {selectedGuidance?.report?.title || "Relatorio"}
                      </p>
                      <p className="details-download-card__date">
                        Enviado em {formatPublishedAt(selectedGuidance?.report)}
                      </p>
                    </div>
                    <img
                      src={downloadIcon}
                      alt="Baixar PDF"
                      className="details-download-card__icon"
                    />
                  </div>
                ) : ''
              }

              <div className="details-actions">
                <BaSeButton
                  type="secondary"
                  buttonType="button"
                  onClick={(event) => {
                    event.preventDefault()
                    closeGuidanceDetails()
                  }}
                  color="#005eb8"
                  value="Voltar"
                />
              </div>
            </div>
          </SideModal>
        ) : ''
      }
    </>
  )
}
